import { ChangeEvent, React, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { RootState } from "../../../redux/reducers/root";
import { getDocument } from "../../../redux/actions/document/document";
import AmpLoadingSpinner from "../../common/AmpLoadingSpinner/AmpLoadingSpinner";
import AmpDropdown from "../../common/AmpDropdown/AmpDropdown";
import propertyImg from "../TempData/scroll_house_default.png";
import "./MyPropertyDocuments.css";
import DocList from "../DocList/DocList";
import AmpButton from "../../common/AmpButton/AmpButton";

interface props {
    propsDocs?: [],
    propsDoc?: {
        documentPDF: {
            pdf: string
        }
    },
    testing?: boolean
}

export interface doc {
    authoritycode: string | null,
    deadlinedate: string | null,
    documentpath: string | null,
    documenttype: string | null,
    effectivedate: string | null,
    emseventid: number | null,
    factid: number | null,
    id: string | null,
    ipspropertyid: number | null,
    ipssnapshotid: number | null,
    maildate: string | null,
    productid: number | null,
    productkey: string | null,
    publisheddate: string,
    region: string | null,
    rollnumber: string | null,
    taxyear: string,
    vendorproductid: string | null,
    vendorproducttype: string,
    FFE?: { type: string, publishedDate: string }
}

export default function MyPropertyDocuments(props: props): JSX.Element {

    const dispatch = useDispatch();
    const { t } = useTranslation(["property", "rfr", "landing"]);

    const tempDocs = props && props.propsDocs
    const tempDoc = props && props.propsDoc?.documentPDF?.pdf
    
    const viewPropertyDetails = useSelector((state: RootState) => state.vwPropertyDetailsReducer.viewPropertyDetails)
    const propertyDocuments = useSelector((state: RootState) => state.propertyDocsReducer.propertyDocuments)
    const documentData = useSelector((state: RootState) => state.docReducer.document)
    // const currentProperty = useSelector((state: RootState) => state.propertyListReducer.currentProperty);

    // const report = useSelector((state: RootState) => state.repReducer?.report)
    const docsLoading = propertyDocuments["loading"]
    const docLoading = documentData["loading"]
    const loading = props.testing ? false : docsLoading
    const currentDocs = props.testing ? tempDocs : propertyDocuments["propertyDocuments"] && propertyDocuments["propertyDocuments"]["data"]
    const pdf = props.testing ? tempDoc : documentData["document"] && documentData["document"]["pdf"]

    const isLink = documentData["document"] && documentData["document"]["is_link"]
    const isPLink = documentData["document"] && documentData["document"]["Partial_link"]

    const vodSessionError = documentData["document"] && documentData["document"]["vod_error"];

    const [fileSource, setFileSource] = useState(pdf);
    const [docId, setDocId] = useState("");
    const [year, setYear] = useState("all")

    // const documents = currentDocs;
    const [documents, setDocuments] = useState([]);
    const currentHost = window.location.protocol + '//' + window.location.hostname;
    const iframeRef = useRef(null);

    useEffect(() => {
        
        if(documents?.length < 1 && currentDocs?.length > 0){
            setDocuments(currentDocs);
            handleDocChange(currentDocs[0].id);

        } else {
            const docs = getCurrentYearDocs(year);
            setDocuments(docs);
        }
        
     //eslint-disable-next-line
    }, [currentDocs, year])
    
    useEffect(() => {
        if (!documentData["loading"] && pdf) {
            if (isPLink) {
                const server = process.env.REACT_APP_AMP_API as string;
                fetchData(server, pdf);
            } else {
                if (isLink){
                    setFileSource(pdf)
                } else {
                    const string = getFileSource(pdf)
                    fetch(string)
                        .then(res => res.blob())
                        .then(data => {
                            const newurl = window.URL.createObjectURL(data)
                            setFileSource(newurl)
                        })
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [documentData, pdf, isLink, isPLink])
    
    const getFileSource = (pdf: string) => {
        return `data:application/pdf;base64,${pdf}`
    }

    const fetchData = async (base: string, pdfstr: string) => {
        try {
            const pdfparts = pdfstr.split("///")
            const token = pdfparts[1]
            const path = pdfparts[0]
            const url = `${base}/${path}`
            const response = await fetch(url, {
            method: 'GET', 
            headers: {
                'Origin': currentHost,
                'Referer': currentHost + "/", 
                'Accept': 'application/pdf',
                'Authorization': token
            },
            });
            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob) + "#embedded=true";
            setFileSource(blobUrl);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const handleBlobLoad = () => {
        if (isPLink) {
            // only modify the sytle of iframe when using blob url
            const iframe = iframeRef.current;
            if (iframe) {
                const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
                if (iframeDocument) {
                    const bodyElement = iframeDocument.querySelector('body');
                    bodyElement.style = "height: 860px !important; width: 100%; overflow: hidden; margin:0px; background-color: black;";
                }
            }
        }
    };

    const getOptions = () => {
        const options: { value: string, text: string }[] = [{ value: "all", text: "VIEW ALL (" + currentDocs.length + ")" }]

        currentDocs.forEach((e: doc) => {
            const year = new Date(e.taxyear)?.getFullYear() + 1
            const value = { value: year.toString(), text: year.toString() }
            const exists = options.some(o => o.value === value.value);
            if (!exists) {
                options.push(value)
            }
        })

        options.sort((a, b) => {
            const year1 = parseInt(a.value)
            const year2 = parseInt(b.value)
            if (year1 && year2) {
                return year2 - year1
            } else {
                return 0
            }
        });

        return options;
    }

    const getCurrentYearDocs = (value: string) => {
        if(!currentDocs) {
            return [];
        }
        let tempDocuments = [...currentDocs]
        if (value !== "all") {
            tempDocuments = currentDocs.filter((e: doc) => (((new Date(e.taxyear))?.getFullYear()) + 1)?.toString() === value)
        }
        return tempDocuments
    }
    const handleSelectChange = (e: ChangeEvent<Element>) => {
        const element = e.currentTarget as HTMLInputElement
        const value = element.value
        const docs = getCurrentYearDocs(value)
        const id = docs[0].id
        if (docId !== id) {
            handleDocChange(id)
        }
        setDocId(id)
        setYear(value)
    }
    const handleDocChange = (id: string, docName?: string) => {
        const currentProperty = window.localStorage.getItem("currentProperty");
        const propertyId = window.localStorage.getItem("propertyId");
        const isFFE = id === "FFE";
        if (!loading) {
            const formInput = {
                "roll": currentProperty,
                "is_report": false,
                "is_meth": false,
                "is_ffe": isFFE,
                "doc_name": docName || null,
                "doc_id": id,
                "property_id": propertyId
            }
            isFFE ? setDocId(docName as string) : setDocId(id);
            dispatch(getDocument(formInput))
        }
    }

    return (
        <div>
            <AmpLoadingSpinner loading={loading}>
                <div className="documents-container">
                    {(currentDocs?.length ?
                        <div className="flex-container">
                            <div className="tabs-container">
                                <div className="property-view-image">
                                    <div className="property-img-documents tax-year-container">
                                        <img src={propertyImg} alt="" />
                                    </div>
                                    <div className="select-tax-year">
                                        <label className="select-label">
                                            {t("vmpd.select-tax-year").toUpperCase() as string}
                                        </label>
                                        <AmpDropdown title="Year dropdown" aria-label="year-dropdown" className="select-box" testid="mpd-dropdown" value={year.toString()} options={getOptions()} onChange={(e) => handleSelectChange(e)} />
                                    </div>
                                </div>
                                <DocList 
                                    docSelect={(id, docName) => handleDocChange(id, docName)} 
                                    loading={loading} 
                                    selectedDoc={docId} 
                                    docs={documents}
                                />
                            </div>
                            <AmpLoadingSpinner loading={docLoading || viewPropertyDetails["loading"]}>
                                <div className="pdf-container">
                                    {/* eslint-disable-next-line */}
                                    {vodSessionError && <div className="rfr-notice-na">
                                    <FontAwesomeIcon icon={faCircleExclamation} size="5x" className="rfr-notice-na-icon" />
                                        <h2>{t("vmpd.session-exp")}</h2>
                                        <AmpButton 
                                            onClick={() => window.location.reload()} type={"submit"} text={t("refresh.button", {ns: "landing"})}>
                                            
                                        </AmpButton>
                                    </div>}
                                    {/* eslint-disable-next-line */}
                                    {!vodSessionError && <iframe allowFullScreen src={fileSource} ref={iframeRef} onLoad={handleBlobLoad} aria-label="prop-pdf-container" style={{ height: '100%', width:"100%" }}/>}
                                </div>
                            </AmpLoadingSpinner>
                        </div> : <div className="rfr-notice-na">
                            <FontAwesomeIcon icon={faCircleExclamation} size="5x" className="rfr-notice-na-icon" />
                            <h2>{t("vmpd.nonotices")}</h2>
                        </div>)
                    }
                </div>
            </AmpLoadingSpinner>
        </div>
    );
}
